
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import {
  ExamV2Custom,
  StructExamRandomConfig
} from "@/lib/model/exambuilder/exam-v2";
import draggable from "vuedraggable";
import {
  QuestionV2Object,
  QuestionV2,
  EnumQuestionType
} from "@/lib/model/exambuilder/question-v2";
import {
  DimensionObject,
  QuestionDimension
} from "@/lib/model/exambuilder/dimension-v2";

import {
  StructExamScoreConfig,
  StructExamQuestionConfig,
  ChoiceQuestionScore
} from "@/lib/model/exambuilder/exam-v2";

import QuestionCardV2 from "@/views/ai-builder-component/question-card-v2/question-card-v2.vue";
import QuestionGroupCard from "@/views/ai-builder-component/question-card-v2/question-group-card.vue";
import QuestionEdit from "@/views/ai-builder-component/components/question-edit.vue";
import Loading from "../../../components/loading.vue";

@Component({
  components: {
    QuestionCardV2,
    QuestionGroupCard,
    QuestionEdit,
    draggable,
    Loading
  }
})
export default class SetQuestion extends Vue {
  @Prop({ type: ExamV2Custom, default: new ExamV2Custom() })
  exam!: ExamV2Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  dimensionMap: Map<string, QuestionDimension> = new Map();
  selectedQuestionList: QuestionV2[] = [];
  selectedDimension: QuestionDimension | null = null;
  editingDimension: QuestionDimension | null = null;

  usedScore = 0; // 已使用分数
  MaxScore = 100;
  remainingScore = 100; // 剩余可分配分数
  activeIndex = -1;

  // 对话框Model
  showCheckData1 = false;
  questionIdMap: any = {};
  showCheckData2 = false;
  showLangCheck = false; // 确认语种配置不一致的确认弹框
  checkLangOk = false; // 是否确认了题目配置语种和面试配置的语种不一样的情况
  checkDimensionText = "";
  currentQuestion: QuestionV2 | null = null;
  showQuestionEdit = false;
  // 数据加载完成前不展示空页面
  dataLoaded = false;
  resetQuestion = 0;

  examDrawQuestionsCount = 0; // 总抽题数量，不能超过100
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答

  //内部使用
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  async mounted() {
    this.initData();
    this.getGroupMap();
    // console.log(this.exam.examRandomConfigList);
  }

  getResetQuestion() {
    let len = 0;
    Object.keys(this.questionIdMap).forEach(key => {
      if (
        !(
          this.questionIdMap[key].length === 1 &&
          this.questionIdMap[key][0] === 0
        )
      ) {
        len += this.questionIdMap[key].length;
      }
    });
    this.resetQuestion = this.exam.questionIdList.length - len;
    // if (this.resetQuestion === 0) {
    //   this.exam.examRandomConfigList = this.exam.examRandomConfigList.filter(el => el.questionList.length > 0)
    // }
  }

  @Watch("exam")
  async initData() {
    if (this.isEdit && !this.exam.isAssigned) return;
    const qo = await DimensionObject.get({
      dimensionKeyList: this.exam.dimensionKeyList,
      isExamEnv: 1, // 历史面试数据兼容需求，写死1
      withExamId: this.exam.examId // 历史面试数据兼容需求，传面试id
    });

    if (qo.list.length < this.exam.dimensionKeyList.length) {
      // 有维度被删除了，需要重新生成维度列表
      this.exam.dimensionKeyList = qo.list.map(dim => {
        return dim.dimensionKey;
      });
    }

    for (const selectedKey of this.exam.dimensionKeyList) {
      for (const dim of qo.list) {
        if (dim.dimensionKey === selectedKey) {
          this.dimensionMap.set(dim.dimensionKey, dim);
        }
      }
    }
    if (this.exam.questionIdList && this.exam.questionIdList.length > 0) {
      const param = {
        questionIdList: this.exam.questionIdList,
        dimensionKeyFilterList: this.exam.dimensionKeyList,
        pageSize: 500,
        isExamEnv: 1, // 历史面试数据兼容需求，写死1
        withExamId: this.exam.examId // 历史面试数据兼容需求，传面试id
      };
      const qo2 = await QuestionV2Object.get(param);
      this.selectedQuestionList = qo2.list;

      if (this.selectedQuestionList.length < this.exam.questionIdList.length) {
        // 数据不一致，有题目被删除，需要重新生成题目list
        this.exam.questionIdList = this.selectedQuestionList.map(question => {
          return question.questionId;
        });
      }

      // this.selectedQuestionList.sort((q1, q2) => {
      //   return (
      //     this.exam.questionIdList.indexOf(Number(q1.questionId)) -
      //     this.exam.questionIdList.indexOf(Number(q2.questionId))
      //   );
      // });
    }
    if (
      this.exam.isRandomQuestions === 1 &&
      this.exam.examRandomConfigList.length === 0
    ) {
      this.exam.examRandomConfigList = [new StructExamRandomConfig()];
    }
    this.initGroupData();
    this.loadDimensionScore();
    this.initScoreConfig();
    this.calcDrawQuestionCount();
    if (this.exam.isRandomQuestions !== 1) {
      this.exam.examRandomConfigList = [];
    }
    this.dataLoaded = true;
  }

  getGroupMap() {
    if (this.exam.isRandomQuestions === 1) {
      this.exam.examRandomConfigList.forEach((el, index) => {
        if (el.questionIdList.length > 0) {
          this.questionIdMap[index] = el.questionIdList;
        }
      });
    }
    this.getResetQuestion();
  }

  addQuestionGroup() {
    this.exam.examRandomConfigList.push(new StructExamRandomConfig());
    this.$nextTick(() => {
      const el = this.$refs[
        "questionCard" + (this.exam.examRandomConfigList.length - 1)
      ];
      if (Array.isArray(el) && el.length > 0) {
        (el[0] as any).editGroup();
      }
    });
  }

  deleteGroup(index: number) {
    // 用index维护map
    this.exam.examRandomConfigList.splice(index, 1);
    delete this.questionIdMap[index];
    for (const key in this.questionIdMap) {
      if (Object.prototype.hasOwnProperty.call(this.questionIdMap, key)) {
        const el = this.questionIdMap[key];
        if (Number(key) > index) {
          // 删除项往下递减1
          const temp = Number(key) - 1;
          delete this.questionIdMap[key];
          this.questionIdMap[temp] = el;
        }
      }
    }
    this.calcExamTotalScore();
    this.getResetQuestion();
  }

  chooseQuestion(questionIdList: number[], index: number) {
    this.questionIdMap[index] = questionIdList;
    this.getResetQuestion();
    if (this.resetQuestion === 0) {
      this.exam.examRandomConfigList = this.exam.examRandomConfigList.filter(
        el => el.questionList.length > 0
      );
    }
  }

  initGroupData() {
    // 将selectedQuestionList，按照组的idList插入到组对象中
    if (this.exam.isRandomQuestions === 1) {
      for (const group of this.exam.examRandomConfigList) {
        group.questionList = [];
        for (const q of this.selectedQuestionList) {
          if (group.questionIdList.indexOf(q.questionId) > -1) {
            group.questionList.push(q);
          }
        }
      }
    }
  }

  initScoreConfig() {
    for (const question of this.selectedQuestionList) {
      if (question.isSingleSelect()) {
        const scoreConfig = this.getScoreConfig(null, question);
        // 选择题需要重建选项分数列表，因为有可能选项被编辑过了，导致选项和分属配置对不上
        if (scoreConfig) {
          const choiceQuestionScoreList = [];
          for (const option of question.optionList) {
            let findConfigItem: ChoiceQuestionScore | null = null;
            if (scoreConfig.choiceQuestionScoreList) {
              for (const optionConfig of scoreConfig.choiceQuestionScoreList) {
                if (optionConfig.optionKey == option.optionKey) {
                  optionConfig.content = option.content;
                  findConfigItem = optionConfig;
                  choiceQuestionScoreList.push(optionConfig);
                  break;
                }
              }
            }
            // 出现了新的选项，默认给0分
            if (!findConfigItem) {
              const optionConfig = new ChoiceQuestionScore();
              optionConfig.optionKey = option.optionKey;
              optionConfig.content = option.content;
              optionConfig.score = 0;
              choiceQuestionScoreList.push(optionConfig);
            }
          }
          scoreConfig.choiceQuestionScoreList = choiceQuestionScoreList;
        }
      }
      //填空题 分配每空分值 gg
      if (question.isBlank() && this.exam.isRandomQuestions === 1) {
        const scoreConfig = this.getScoreConfig(null, question);
        if (scoreConfig) {
          scoreConfig.blankQuestionScoreList = [];
          if (question.blankQuestionConfig.scoreType === 3) {
            //每空分数独立计分 3  根据每空分数比例分配
            const scoreList: number[] = [];
            question.blankQuestionConfig.answerList.forEach((an, i) => {
              if (i < question.blankQuestionConfig.answerList.length - 1) {
                scoreList.push(
                  Math.floor(
                    Number((an.score / 100) * scoreConfig.dimensionScore)
                  )
                );
              } else {
                scoreList.push(
                  scoreConfig.dimensionScore -
                    scoreList.reduce((a, b) => a + b, 0)
                );
              }
            });
            scoreConfig.dimensionScore = scoreList.reduce((a, b) => a + b, 0);
            scoreConfig.blankQuestionScoreList = scoreList;
          } else {
            //整体比例计分 1 2； 此时只需题目总分
            scoreConfig.dimensionScore = 0; // 冗余字段 // 填空题 = sum(blankQuestionScoreList)
            scoreConfig.blankQuestionScoreList = [0];
          }
        }
      }
      // }
    }
  }

  loadDimensionScore() {
    this.remainingScore = 100;
    if (
      !this.isEdit &&
      (this.exam.examScoreConfigList.length === 0 ||
        (!this.exam.examScoreConfigList[1] &&
          // 抽题组卷不默认配分
          (this.exam.isRandomQuestions !== 1 ||
            this.exam.examRandomConfigList.length === 0 ||
            // model初始化有个默认项
            !this.exam.examRandomConfigList[1]?.name)))
    ) {
      // 加载默认配置
      return this.setDefaultTotalScore();
    } else {
      // 加载历史配置需要兼容缺少的项
      const questionMap = {};
      // 需要把缺少的维度补充到config
      for (const q of this.selectedQuestionList) {
        questionMap[q.questionId] = q;
        for (const dim of q.dimensionListFilter) {
          let hasFindHistoryData = false;
          for (const config of this.exam.examScoreConfigList) {
            if (
              config.dimensionKey === dim.dimensionKey &&
              config.questionId == q.questionId
            ) {
              hasFindHistoryData = true;
            }
          }
          if (!hasFindHistoryData) {
            console.log("err");
            this.setQuestionDimensonScore(q, dim.dimensionKey, 0);
          }
        }
      }
      // 需要把已经删除的维度从config里删掉
      for (let i = 0; i < this.exam.examScoreConfigList.length; i++) {
        const scoreConfig = this.exam.examScoreConfigList[i];
        const question: QuestionV2 = questionMap[scoreConfig.questionId];
        console.log("💩 ~ loadDimensionScore ~ question:", question);
        const dimensionKeyList = question?.dimensionListFilter.map(
          d => d.dimensionKey
        );
        if (!question) {
          this.exam.examScoreConfigList.splice(i, 1);
          i--;
        } else {
          if (dimensionKeyList.indexOf(scoreConfig.dimensionKey) < 0) {
            this.exam.examScoreConfigList.splice(i, 1);
            i--;
          }
        }
      }
      // this.exam.examScoreConfigList = this.exam.examScoreConfigList.filter(
      //   scoreConfig => {
      //     let needDelete = false;
      //     const question: QuestionV2 = questionMap[scoreConfig.questionId];
      //     if (!question) {
      //       needDelete = true;
      //     } else {
      //       if (
      //         question.dimensionListFilter
      //           .map(d => {
      //             return d.dimensionKey;
      //           })
      //           .indexOf(scoreConfig.dimensionKey) < 0
      //       )
      //         needDelete = true;
      //     }
      //     return !needDelete;
      //   }
      // );

      this.calcDimensionTotalScore();
      if (this.exam.isRandomQuestions === 1) this.calcQuestionGroupTotalScore();
      else this.calcQuestionTotalScore();
      this.calcExamTotalScore();
    }
  }

  scrollIntoGroup(index: number) {
    this.activeIndex = index;
    const el = this.$refs["questionGroup" + index];
    if (Array.isArray(el) && el.length > 0) {
      (el[0] as HTMLElement).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }

  setDefaultTotalScore() {
    // 考试总分为100
    this.exam.examScoreConfigList = [];
    this.remainingScore = 100;
    if (this.exam.isRandomQuestions === 1) {
      this.remainingScore = 0;
    }
    const avgScore =
      this.exam.isRandomQuestions === 1
        ? 0
        : Math.round(this.remainingScore / this.dimensionMap.size);
    const iterator = this.dimensionMap.values();
    let r: IteratorResult<QuestionDimension>;

    let index = 0;
    while (((r = iterator.next()), !r.done)) {
      const dim = r.value;
      if (
        avgScore <= this.remainingScore &&
        index != this.dimensionMap.size - 1
      ) {
        this.setDimTotalScore(dim, avgScore);
      } else {
        this.setDimTotalScore(dim, this.remainingScore);
      }
      this.remainingScore -= dim.totalScore;
      index++;
    }
  }

  setDimTotalScore(dim: QuestionDimension, score: number) {
    dim.totalScore = score;
    let remainingScore = dim.totalScore;

    if (this.exam.isRandomQuestions !== 1) {
      const questionList = this.filterQuestionList(dim.dimensionKey);

      if (questionList.length) {
        const avgScore = Math.round(dim.totalScore / questionList.length);
        for (const i in questionList) {
          let score = 0; // 题目该维度应该分配的分值
          if (
            avgScore <= remainingScore &&
            Number(i) != questionList.length - 1
          ) {
            score = avgScore;
          } else {
            score = remainingScore;
          }
          this.setQuestionDimensonScore(
            questionList[i],
            dim.dimensionKey,
            score
          );
          remainingScore -= score;
        }
      }
    } else {
      const questionGroupList = this.filterQuestionGroupList(dim.dimensionKey);
      if (questionGroupList.length) {
        const avgScore = Math.round(dim.totalScore / questionGroupList.length);

        for (const i in questionGroupList) {
          let score = 0; // 题目该维度应该分配的分值
          if (
            avgScore <= remainingScore &&
            Number(i) != questionGroupList.length - 1
          ) {
            score = avgScore;
          } else {
            score = remainingScore;
          }
          this.setQuestionGroupDimensonScore(
            questionGroupList[i],
            dim.dimensionKey,
            score
          );
          remainingScore -= score;
        }
      }
    }
  }

  // 因为题目变化，导致维度分数变动
  onQuestionCardScoreChange(
    question: QuestionV2,
    dimKey: string,
    score: number
  ) {
    // 分配完成分数后，需要计算题目总分、维度总分和试卷总分 gg
    this.calcQuestionTotalScore(question);
    this.calcDimensionTotalScore(dimKey);
    this.calcExamTotalScore();
  }

  // 因为题目分组变化，导致维度分数变动
  onQuestionGroupCardScoreChange(
    questionGroup: StructExamRandomConfig,
    dimKey: string,
    score: number
  ) {
    // 分配完成分数后，需要计算题目总分、维度总分和试卷总分
    this.calcQuestionGroupTotalScore(questionGroup);
    this.calcDimensionTotalScore(dimKey);
    this.calcExamTotalScore();
  }

  changeQuestionNumber(questionGroup: StructExamRandomConfig) {
    this.calcQuestionGroupTotalScore(questionGroup);
    this.calcExamTotalScore();
    this.calcDrawQuestionCount();
  }

  // 计算抽题总数，防止超过
  calcDrawQuestionCount() {
    let examDrawQuestionsCount = 0;
    for (const group of this.filterQuestionGroupList()) {
      examDrawQuestionsCount += group.questionNumber;
    }
    this.examDrawQuestionsCount = examDrawQuestionsCount;
  }

  // 修改某道题某维度的分数
  setQuestionDimensonScore(
    question: QuestionV2,
    dimKey: string,
    score: number
  ) {
    const config = this.getScoreConfig(dimKey, question);
    config.videoQuestionScore = score;
    config.dimensionScore = score;

    // 为选择题重新分配分数
    if (
      question.questionType === EnumQuestionType.EnumQuestionTypeSingleChoice ||
      question.questionType === EnumQuestionType.EnumQuestionTypeNewSingleChoice
    ) {
      config.choiceQuestionScoreList = [];
      for (const option of question.optionList) {
        const optionConfig = new ChoiceQuestionScore();
        optionConfig.optionKey = option.optionKey;
        optionConfig.content = option.content;
        if (option.defaultScorePercent != undefined)
          optionConfig.score = Math.max(
            -100,
            Math.round(
              (Number(option.defaultScorePercent) * config.dimensionScore) / 100
            )
          );
        config.choiceQuestionScoreList.push(optionConfig);
      }
    }
    //填空题 分配每空分值 gg
    if (question.questionType === EnumQuestionType.EnumQuestionTypeBlanks) {
      config.dimensionKey = dimKey;
      config.questionId = question.questionId;
      config.blankQuestionScoreList = [];
      if (question.blankQuestionConfig.scoreType === 3) {
        //每空分数独立计分 3  根据每空分数比例分配
        const scoreList: number[] = [];
        question.blankQuestionConfig.answerList.forEach((an, i) => {
          if (i < question.blankQuestionConfig.answerList.length - 1) {
            scoreList.push(Math.floor(Number((an.score / 100) * score)));
          } else {
            scoreList.push(score - scoreList.reduce((a, b) => a + b, 0));
          }
        });
        config.dimensionScore = scoreList.reduce((a, b) => a + b, 0);
        config.blankQuestionScoreList = scoreList;
      } else {
        //整体比例计分 1 2； 此时只需题目总分
        config.dimensionScore = score; // 冗余字段 // 填空题 = sum(blankQuestionScoreList)
        config.blankQuestionScoreList = [score];
      }
    }

    // 分配完成分数后，需要计算题目总分、维度总分和试卷总分
    this.calcQuestionTotalScore(question);
    this.calcExamTotalScore();
  }

  // 修改某题目分组某维度的分数
  setQuestionGroupDimensonScore(
    questionGroup: StructExamRandomConfig,
    dimKey: string,
    score: number
  ) {
    for (const config of questionGroup.dimensionScoreConfigList) {
      if (config.dimensionKey == dimKey) {
        config.dimensionScore = score;
      }
    }

    // 为选择题重新分配分数
    if (questionGroup.isSingleSelect()) {
      for (const question of questionGroup.questionList) {
        const config = this.getScoreConfig(dimKey, question);
        config.videoQuestionScore = score;
        config.dimensionScore = score;

        config.choiceQuestionScoreList = [];
        for (const option of question.optionList) {
          const optionConfig = new ChoiceQuestionScore();
          optionConfig.optionKey = option.optionKey;
          optionConfig.content = option.content;
          if (option.defaultScorePercent != undefined)
            optionConfig.score = Math.round(
              (Number(option.defaultScorePercent) * config.dimensionScore) / 100
            );
          config.choiceQuestionScoreList.push(optionConfig);
        }
      }
    }
    // 分配完成分数后，需要计算题目总分、维度总分和试卷总分
    this.calcQuestionGroupTotalScore(questionGroup);
    this.calcDimensionTotalScore(dimKey);
    this.calcExamTotalScore();
  }

  getScoreConfig(
    dimKey: string | null,
    question: QuestionV2
  ): StructExamScoreConfig {
    for (const config of this.exam.examScoreConfigList) {
      if (
        (config.dimensionKey === dimKey ||
          question.isSingleSelect() ||
          question.isBlank()) &&
        config.questionId == question.questionId
      ) {
        return config;
      }
    }
    const config = new StructExamScoreConfig();
    config.questionId = question.questionId;
    if (dimKey) config.dimensionKey = dimKey;
    else if (question.dimensionListOrigin.length > 0)
      config.dimensionKey = question.dimensionListOrigin[0].dimensionKey;
    this.exam.examScoreConfigList.push(config);
    return config;
  }

  getQuestionConfig(question: QuestionV2): StructExamQuestionConfig {
    for (const config of this.exam.examQuestionConfigList) {
      if (config.questionId == question.questionId) {
        return config;
      }
    }
    const config = new StructExamQuestionConfig();
    config.questionId = question.questionId;
    this.exam.examQuestionConfigList.push(config);
    return config;
  }

  calcQuestionGroupTotalScore(
    questionGroup: StructExamRandomConfig | null = null
  ) {
    if (questionGroup) {
      // 计算题目总分
      questionGroup.totalScore = 0;
      for (const config of questionGroup.dimensionScoreConfigList) {
        questionGroup.totalScore += config.dimensionScore;
      }
    } else {
      // 计算全部题目的总分
      for (const g of this.exam.examRandomConfigList) {
        this.calcQuestionGroupTotalScore(g);
      }
    }
  }

  calcQuestionTotalScore(question: QuestionV2 | null = null) {
    if (question) {
      // 计算题目总分
      question.totalScore = 0;
      for (const config of this.exam.examScoreConfigList) {
        if (question.questionId === config.questionId)
          question.totalScore += config.dimensionScore;
      }
    } else {
      // 计算全部题目的总分
      for (const q of this.selectedQuestionList) {
        this.calcQuestionTotalScore(q);
      }
    }
  }

  calcDimensionTotalScore(dimKey: string | null = null) {
    const scoreMap = {};
    // 计算维度的总分
    if (this.exam.isRandomQuestions !== 1) {
      for (const config of this.exam.examScoreConfigList) {
        if (!dimKey || config.dimensionKey === dimKey) {
          if (
            Object.prototype.hasOwnProperty.call(scoreMap, config.dimensionKey)
          ) {
            scoreMap[config.dimensionKey] += config.dimensionScore;
          } else {
            scoreMap[config.dimensionKey] = config.dimensionScore;
          }
        }
      }

      if (dimKey) {
        const dim = this.dimensionMap.get(dimKey);
        if (dim) dim.totalScore = scoreMap[dim.dimensionKey];
      } else {
        const iterator = this.dimensionMap.values();
        let r: IteratorResult<QuestionDimension>;
        while (((r = iterator.next()), !r.done)) {
          const dim = r.value;
          dim.totalScore = scoreMap[dim.dimensionKey]
            ? scoreMap[dim.dimensionKey]
            : 0;
        }
      }
    } else {
      for (const questionGroup of this.exam.examRandomConfigList) {
        for (const config of questionGroup.dimensionScoreConfigList) {
          if (!dimKey || config.dimensionKey === dimKey) {
            if (
              Object.prototype.hasOwnProperty.call(
                scoreMap,
                config.dimensionKey
              )
            ) {
              scoreMap[config.dimensionKey] += config.dimensionScore;
            } else {
              scoreMap[config.dimensionKey] = config.dimensionScore;
            }
          }
        }
      }

      if (dimKey) {
        const dim = this.dimensionMap.get(dimKey);
        if (dim) dim.totalScore = scoreMap[dim.dimensionKey];
      } else {
        const iterator = this.dimensionMap.values();
        let r: IteratorResult<QuestionDimension>;
        while (((r = iterator.next()), !r.done)) {
          const dim = r.value;
          dim.totalScore = scoreMap[dim.dimensionKey]
            ? scoreMap[dim.dimensionKey]
            : 0;
        }
      }
    }
  }

  calcExamTotalScore() {
    if (this.exam.isRandomQuestions === 1) {
      let usedScore = 0;
      this.exam.examRandomConfigList.forEach(el => {
        usedScore += el.totalScore * el.questionNumber;
      });
      this.usedScore = usedScore;
    } else {
      let usedScore = 0;
      const iterator = this.dimensionMap.values();
      let r: IteratorResult<QuestionDimension>;

      while (((r = iterator.next()), !r.done)) {
        const dim = r.value;
        usedScore += Number(dim.totalScore);
      }
      this.usedScore = usedScore;
    }
    this.onDataChange();
  }

  onDataChange() {
    this.change();
  }

  selectDimenson(dim: QuestionDimension | null) {
    if (this.selectedDimension !== dim) {
      this.selectedDimension = dim;
    }
    if (this.$refs.questionContent) {
      (this.$refs.questionContent as HTMLElement).scrollTop = 0;
    }
  }

  onBlurDimensonInput(dim: QuestionDimension, e: any) {
    this.editingDimension = null;
    // const value = Math.min(100, Number(e.target.value));//触发方法从blur改成change了
    const value = Math.min(100, Number(e));
    this.setDimTotalScore(dim, value);
  }

  onFocusDimensonInput(dim: QuestionDimension, event: any) {
    event.currentTarget.select();
    this.editingDimension = dim;
  }

  getQuestionIndex(questionId: number) {
    // console.log(this.exam.questionIdList);
    return this.exam.questionIdList.indexOf(Number(questionId));
  }

  getQuestionGroupIndex(group: any) {
    // console.log(this.exam.questionIdList);
    return this.exam.examRandomConfigList.indexOf(group);
  }

  filterQuestionList(dimensionkey: string | null = null) {
    return this.selectedQuestionList.filter((q: QuestionV2) => {
      if (!this.selectedDimension && !dimensionkey) return true;
      for (const dim of q.dimensionListOrigin) {
        if (
          (dimensionkey && dim.dimensionKey === dimensionkey) ||
          (!dimensionkey &&
            this.selectedDimension &&
            dim.dimensionKey === this.selectedDimension.dimensionKey)
        ) {
          return true;
        }
      }
      return false;
    });
  }

  filterQuestionGroupList(dimensionkey: string | null = null) {
    return this.exam.examRandomConfigList.filter(
      (c: StructExamRandomConfig) => {
        if (!this.selectedDimension && !dimensionkey) return true;
        for (const dim of c.dimensionScoreConfigList) {
          if (
            (dimensionkey && dim.dimensionKey === dimensionkey) ||
            (!dimensionkey &&
              this.selectedDimension &&
              dim.dimensionKey === this.selectedDimension.dimensionKey)
          ) {
            return true;
          }
        }
        return false;
      }
    );
  }

  getDimensionItemClass(dimension: QuestionDimension | null) {
    // if (
    //   dimension &&
    //   this.editingDimension &&
    //   this.editingDimension.dimensionKey == dimension.dimensionKey
    // )
    //   return "dimension-item-editing";
    // else
    if (!dimension) {
      return "dimension-item-err";
    } else if (
      (!dimension && !this.selectedDimension) ||
      (this.selectedDimension &&
        dimension &&
        this.selectedDimension.dimensionKey == dimension.dimensionKey)
    )
      return "dimension-item-highlight";
    else return "";
  }

  // 编辑题目
  onEditQuestion(question: any) {
    //AI视频题 和 系统选择题 不可修改
    if (
      (question.questionType === 6 && question.isAiQuestion === 1) ||
      (question.questionType === 7 && question.isSystemQuestion === 1)
    ) {
      return;
    }
    this.currentQuestion = question;
    this.showQuestionEdit = true;
  }

  // 关闭编辑题目
  onCloseEditQuestion(hasChanged: boolean) {
    this.currentQuestion = null;
    this.showQuestionEdit = false;
    if (hasChanged) {
      this.initData();
    }
  }

  //移动至第几题
  sort(to: any, from: number) {
    if (this.exam.isRandomQuestions !== 1) {
      // 非抽提组卷时，排序题目
      const temp = this.exam.questionIdList[from];
      this.exam.questionIdList.splice(from, 1);
      this.exam.questionIdList.splice(Number(to) - 1, 0, temp);

      this.selectedQuestionList.sort((q1, q2) => {
        return (
          this.exam.questionIdList.indexOf(Number(q1.questionId)) -
          this.exam.questionIdList.indexOf(Number(q2.questionId))
        );
      });
      this.change();
    } else {
      // 抽提组卷时，排序题目组
      const temp = this.exam.examRandomConfigList[from];
      this.exam.examRandomConfigList.splice(from, 1);
      this.exam.examRandomConfigList.splice(Number(to) - 1, 0, temp);
      // 维护index存储的map
      this.questionIdMap = {};
      this.getGroupMap();
      this.change();
    }
  }

  // 校验是否存在抽取0题的题目组
  checkZeroGroup() {
    return this.exam.examRandomConfigList.every(el => el.questionNumber > 0);
  }

  //离开前数据校验
  checkData() {
    // 检查一下是否题目配置的语种和面试配置的语种有不一样的情况
    const isMultiLang = this.exam.examQuestionConfigList.some(
      v => v.lang !== this.exam.lang
    );
    if (!this.checkLangOk && isMultiLang) {
      this.showLangCheck = true;
      return false;
    }
    if (
      this.exam.isRandomQuestions === 1 &&
      this.examDrawQuestionsCount > 100
    ) {
      this.$message.error("单场面试抽题数量之和最多100题");
      return false;
    }

    let flag = true;
    if (this.exam.isRandomQuestions === 1) {
      flag = this.resetQuestion === 0 && this.checkZeroGroup();
    }
    const isOk =
      this.checkTotalScore() &&
      this.checkDimensionScore() &&
      this.checkQuestionScore() &&
      flag;
    if (this.exam.isRandomQuestions === 1 && this.resetQuestion > 0) {
      this.$message.error("需要将本场面试的所有题目放置在抽题组中！");
      return false;
    }
    if (this.exam.isRandomQuestions === 1 && !this.checkZeroGroup()) {
      this.$message.error("抽题组内不能抽取0道题目！");
      return false;
    }

    if (isOk) this.change();
    return isOk;
  }

  // 检查题目总分为100
  checkTotalScore() {
    if (this.usedScore > this.MaxScore) {
      this.$message.error("当前面试分数超过100分，请调整至100分");
    } else if (this.usedScore < this.MaxScore) {
      this.$message.error("当前面试分数不足100分，请调整至100分");
    }
    return this.usedScore === this.MaxScore;
  }

  // 检查维度分数不为0
  checkDimensionScore() {
    const errorDimensions = [];
    this.checkDimensionText = "";
    // 不要用map.forEach迭代，因为这里需要同步拿到结果
    const iterator = this.dimensionMap.values();
    let r: IteratorResult<QuestionDimension>;
    while (((r = iterator.next()), !r.done)) {
      const dim = r.value;
      if (dim.totalScore == 0) {
        errorDimensions.push("【" + dim.dimensionName + "】");
        this.showCheckData1 = true;
      }
    }
    if (errorDimensions.length > 0) {
      this.checkDimensionText =
        "当前" +
        errorDimensions.join("") +
        "的分值为0，在候选人面试完成后将不显示此维度的考核结果";
    }
    return errorDimensions.length == 0;
  }

  // 检查题目分数合法
  checkQuestionScore() {
    if (this.exam.isRandomQuestions !== 1) {
      // 非抽题组卷
      for (const question of this.selectedQuestionList) {
        if (question.totalScore === 0) {
          this.showCheckData2 = true;
          return false;
        }
      }
    } else {
      // 抽题组卷
      for (let i = 0; i < this.exam.examRandomConfigList.length; i++) {
        const group = this.exam.examRandomConfigList[i];
        if (group.isSingleSelect()) {
          for (const question of group.questionList) {
            let maxScore = 0;
            const scoreConfig = this.getScoreConfig(null, question);
            for (const optionConfig of scoreConfig.choiceQuestionScoreList) {
              if (optionConfig.score > maxScore) {
                maxScore = optionConfig.score;
              }
            }

            if (maxScore != group.totalScore) {
              this.$message.error("请保证所有题目的选项最大值相等");
              this.goToErrorOption(i, question.questionId);
              return false;
            }
          }
        }
      }
    }
    return true;
  }
  //跳到分数异常的题组
  goToErrorOption(groupIndex: number, questionId: any) {
    this.exam.examRandomConfigList[groupIndex].expand = true;
    (this.$refs?.questionGroupIndex?.[
      groupIndex
    ] as HTMLElement).scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
  filterScoreZeroQuestion() {
    return this.selectedQuestionList.filter((q: QuestionV2) => {
      return q.totalScore == 0;
    });
  }

  // 检查数据取消
  cancelCheckData() {
    this.showCheckData1 = false;
    this.showCheckData2 = false;
    this.showLangCheck = false;
  }

  // 检查数据中，确认下一步
  checkConfirm(checkStep = 1) {
    this["showCheckData" + checkStep] = false;
    if (checkStep == 2 || this.checkQuestionScore()) {
      this.nextStep();
    }
  }

  // 检查语种的弹框点击了确认
  checkLangConfirm(checkStep = 1) {
    this.checkLangOk = true;
    this.showLangCheck = false;
    this.nextStep();
  }

  onCloseOtherPop(questionId: number) {
    if (this.$refs.questionCard && this.$refs.questionCard instanceof Array) {
      for (const questionCard of this.$refs.questionCard) {
        (questionCard as QuestionCardV2).onCloseOtherPop(questionId);
      }
    }
  }

  @Emit()
  nextStep() {
    return;
  }
  @Emit()
  change() {
    return;
  }
}
